import { BehaviorSubject } from 'rxjs';
import { Component, Input } from '@angular/core';

import { fromWeatherCodeToWeatherIcon, fromWeatherCodeToWeatherBackground, WeatherIcon, WeatherInfo } from 'ngx-core-services';

export type ExtraWeatherInfo = WeatherInfo & {
  background: string;
  weatherIcon: WeatherIcon;
};

@Component({
  selector: 'lib-weather-card',
  templateUrl: './weather-card.component.html',
  styleUrls: ['./weather-card.component.scss'],
})
export class WeatherCardComponent {
  readonly weatherInfo$ = new BehaviorSubject<ExtraWeatherInfo | null>(null);
  @Input() set weatherInfo(value: WeatherInfo | null) {
    if (value) {
      const extraWeatherInfo: ExtraWeatherInfo = {
        ...value,
        weatherIcon: fromWeatherCodeToWeatherIcon(value.weather[0].icon),
        background: fromWeatherCodeToWeatherBackground(value.weather[0].icon),
      };
      this.weatherInfo$.next(extraWeatherInfo);
    }
  }
}
